<template>
  <div>
    <Form ref="myForm" :label-width="110">
      <FormItem  :label="rowData.type === 0 ? '展会名称' : '论坛名称'" prop="title">
        <Input v-model="rowData.title" placeholder="请输入标题" readonly></Input>
      </FormItem>
      <Row>
        <Col span="12">
          <FormItem :label="rowData.type === 0 ? '展会主图' : '论坛主图'" prop="images">
            <div class="demo-upload-list">
              <img :src="rowData.images">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(rowData.images)"></Icon>
              </div>
            </div>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="微信分享背景图" prop="images">
            <div class="demo-upload-list">
              <img :src="rowData.share_image">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(rowData.share_image)"></Icon>
              </div>
            </div>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem :label="rowData.type === 0 ? '参展登记图' : '演讲登记图'" prop="register_provider_images">
            <div class="demo-upload-list">
              <img :src="rowData.register_provider_images">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(rowData.register_provider_images)"></Icon>
              </div>
            </div>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="rowData.type === 0 ? '参观登记图' : '参会登记图'" prop="register_join_images">
            <div class="demo-upload-list">
              <img :src="rowData.register_join_images">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(rowData.register_join_images)"></Icon>
              </div>
            </div>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem :label="rowData.type === 0 ? '参展价格' : '演讲价格'" prop="join_price">
            <Input v-model="rowData.join_price" readonly></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="rowData.type === 0 ? '参观价格' : '参会价格'" prop="provider_price">
            <Input v-model="rowData.provider_price" readonly></Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="活动日期" prop="date">
            <Row>
              <Col span="12">
                <Date-picker v-model="rowData.date" format="yyyy-MM-dd HH:mm" type="datetimerange" placement="bottom-end" readonly placeholder="选择日期" style="width: 350px"></Date-picker>
              </Col>
            </Row>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="活动地址" prop="address">
            <Input  v-model="rowData.address" readonly></Input>
          </FormItem>
        </Col>
      </Row>

      <FormItem label="基本信息" prop="basic_info">
        <tinymce  v-model="rowData.basic_info" disabled></tinymce>
      </FormItem>
      <FormItem :label="rowData.type === 0 ? '展会详情' : '会议详情'" prop="meeting_detail">
        <tinymce  v-model="rowData.meeting_detail" disabled></tinymce>
      </FormItem>
      <FormItem :label="rowData.type === 0 ? '参展费用' : '会议议程'" prop="meeting_agenda">
        <tinymce  v-model="rowData.meeting_agenda" disabled></tinymce>
      </FormItem>
      <FormItem :label="rowData.type === 0 ? '参展须知' : '参会须知'" prop="participation_notice">
        <tinymce  v-model="rowData.participation_notice" disabled></tinymce>
      </FormItem>
    </Form>
    <Modal title="大图预览" v-model="imageVisible">
      <img :src="imageName" v-if="imageVisible" style="width: 100%">
    </Modal>
  </div>
</template>

<script>

import tinymce from '../../../components/tinymce/index'

export default {
  name: 'detail',
  components: { tinymce },
  props: {
    rowData: {
      type: Object
    }
  },
  data () {
    return {
      imageVisible: false,
      imageName: ''
    }
  },
  methods: {
    handleView (name) {
      this.imageName = name
      this.imageVisible = true
    }
  }
}
</script>

<style scoped>
  .demo-upload-list{
    display: inline-block;
    width: 90px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
